'use strict';

exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp2; // import SubscriptionProvider from "./components/SubscriptionProvider";
// import ContextProvider from "./components/ContextProvider";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./styles/less/styles.css');

var _context2 = require('@prisma-cms/context');

var _context3 = _interopRequireDefault(_context2);

var _materialUi = require('material-ui');

var _Close = require('material-ui-icons/Close');

var _Close2 = _interopRequireDefault(_Close);

var _AddFilter = require('./dev/Renderer/pages/MainPage/AddFilter');

var _AddFilter2 = _interopRequireDefault(_AddFilter);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // export {
//   ContextProvider,
//   SubscriptionProvider,
// }


var App = (_temp2 = _class = function (_Component) {
  _inherits(App, _Component);

  function App() {
    var _temp, _this, _ret;

    _classCallCheck(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.setFilters = function (filters) {
      var setFilters = _this.props.setFilters;
      return setFilters(filters);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  App.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;
    /**
     * Бывает, не сразу перерендеривается после получения схемы,
     * поэтому обновляем компонент
     */


    setTimeout(function () {
      return _this2.forceUpdate();
    }, 1000);
    _Component.prototype.componentDidMount && _Component.prototype.componentDidMount.call(this);
  };
  /**
   * Устанавливаем новые фильтры
   */


  App.prototype.renderInputBlock = function renderInputBlock(field, name, key, filters, setFilters, deleteItem, title) {
    var Grid = this.context.Grid;
    return _react2.default.createElement(_react.Fragment, {
      key: key
    }, _react2.default.createElement(Grid, {
      item: true
    }, title ? _react2.default.createElement(_materialUi.Typography, {
      variant: 'subheading'
    }, title) : null, field), _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(_materialUi.IconButton, {
      onClick: deleteItem ? deleteItem : function (event) {
        var newFilters = _extends({}, filters);

        delete newFilters[name];
        setFilters(newFilters);
      }
    }, _react2.default.createElement(_Close2.default, null))));
  };

  App.prototype.getType = function getType(type) {
    var isList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isNonNull = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var kind = type.kind,
        ofType = type.ofType;

    switch (kind) {
      case "LIST":
        return this.getType(ofType, true, isNonNull);
        break;

      case "NON_NULL":
        return this.getType(ofType, isList, true);
        break;
    }

    return {
      Type: type,
      isList: isList,
      isNonNull: isNonNull
    };
  };

  App.prototype.renderFilters = function renderFilters(filters, setFilters, deleteItem, props, __inputFields, inputFields) {
    var _this3 = this;

    if (!inputFields) {
      return null;
    }

    var Grid = this.context.Grid;

    if (!filters) {
      return null;
    }

    var _ref = props || {},
        style = _ref.style,
        other = _objectWithoutProperties(_ref, ['style']);

    var inputs = [];
    var names = Object.keys(filters);
    var values = Object.values(filters);
    names.map(function (name, index) {
      var newName = name;
      var value = values[index];
      var input = void 0;

      if (value && Array.isArray(value)) {
        var fields = [];
        value.map(function (n, index) {
          var _this3$renderFilters;

          var fieldName = name + ' (' + (index + 1) + ')';
          fields.push(_this3.renderFilters((_this3$renderFilters = {}, _this3$renderFilters[fieldName] = n, _this3$renderFilters), function (newFilters) {
            var _Object$assign;

            var values = [].concat(value);
            values[index] = Object.values(newFilters)[0];
            var NewFilters = Object.assign(_extends({}, filters), (_Object$assign = {}, _Object$assign[name] = values, _Object$assign));
            setFilters(NewFilters);
          }, function (event) {
            var values = [].concat(value);
            values.splice(index, 1);

            var newFilters = _extends({}, filters);

            newFilters[name] = values;
            setFilters(newFilters);
          }, {
            key: fieldName
          }));
        });
        input = _this3.renderInputBlock(fields, name, index, filters, setFilters, deleteItem, name);
      }
      /**
       * Вложенные объекты
       */
      else if (value && value instanceof Object) {
          var inputType = inputFields.find(function (n) {
            return n && n.name === name;
          });

          var _ref2 = inputType && inputType.type || {},
              whereTypeName = _ref2.name;

          var fieldInputFields = whereTypeName ? _this3.getInputFields(whereTypeName) : [];

          var field = _this3.renderFilters(value, function (newFilters) {
            var _Object$assign2;

            var NewFilters = Object.assign(_extends({}, filters), (_Object$assign2 = {}, _Object$assign2[name] = newFilters, _Object$assign2));
            setFilters(NewFilters);
          }, null, null, null, // inputType,
          fieldInputFields);

          input = _react2.default.createElement(Grid, {
            key: index,
            item: true
          }, _react2.default.createElement(Grid, {
            container: true,
            spacing: 8,
            style: {
              border: "1px solid grey"
            }
          }, _this3.renderInputBlock(field, name, index, filters, setFilters, deleteItem, name), _react2.default.createElement(Grid, {
            item: true
          }, _react2.default.createElement(_materialUi.Button, {
            size: 'small',
            onClick: function onClick(event) {
              var _Object$assign3;

              setFilters(Object.assign(_extends({}, filters), (_Object$assign3 = {}, _Object$assign3[name] = null, _Object$assign3)));
            }
          }, 'Set null'))));
        } else {
          /**
           * Выводим конечное поле.
           * Здесь сразу еще и определяем тип поля (строка/число/логическое/список)
           */
          var _field = void 0;

          var fieldByName = inputFields.find(function (n) {
            return n.name === name;
          });

          if (fieldByName) {
            var _fieldByName$type = fieldByName.type,
                typeKind = _fieldByName$type.kind,
                typeName = _fieldByName$type.name;

            switch (typeKind) {
              case "SCALAR":
                switch (typeName) {
                  case "Boolean":
                    if (typeof value === "boolean") {
                      _field = _react2.default.createElement(_materialUi.FormControlLabel, {
                        control: _react2.default.createElement(_materialUi.Switch, {
                          name: name,
                          checked: value === true,
                          color: 'primary',
                          onChange: function onChange(event, checked) {
                            var _Object$assign4; // const {
                            //   name,
                            //   value,
                            // } = event.target;


                            setFilters(Object.assign(_extends({}, filters), (_Object$assign4 = {}, _Object$assign4[name] = checked, _Object$assign4)));
                          } // {...other}

                        }),
                        label: name // fullWidth

                      });
                    } else {
                      _field = _react2.default.createElement(Grid, {
                        container: true,
                        spacing: 8
                      }, _react2.default.createElement(Grid, {
                        item: true
                      }, _react2.default.createElement(_materialUi.Button, {
                        size: 'small',
                        color: 'primary',
                        onClick: function onClick(event) {
                          var _Object$assign5;

                          setFilters(Object.assign(_extends({}, filters), (_Object$assign5 = {}, _Object$assign5[name] = true, _Object$assign5)));
                        }
                      }, 'True')), _react2.default.createElement(Grid, {
                        item: true
                      }, _react2.default.createElement(_materialUi.Button, {
                        size: 'small',
                        color: 'secondary',
                        onClick: function onClick(event) {
                          var _Object$assign6;

                          setFilters(Object.assign(_extends({}, filters), (_Object$assign6 = {}, _Object$assign6[name] = false, _Object$assign6)));
                        }
                      }, 'False')));
                    }

                    break;

                  case "Int":
                  case "Float":
                    _field = _react2.default.createElement(_materialUi.TextField, {
                      name: name,
                      label: name,
                      value: value || "",
                      type: 'number',
                      onChange: function onChange(event) {
                        var _Object$assign7;

                        var _event$target = event.target,
                            name = _event$target.name,
                            value = _event$target.value;
                        setFilters(Object.assign(_extends({}, filters), (_Object$assign7 = {}, _Object$assign7[name] = Number(value), _Object$assign7)));
                      }
                    });
                    break;

                  default:
                    _field = _react2.default.createElement(_materialUi.TextField, {
                      name: name,
                      label: name,
                      value: value || "",
                      onChange: function onChange(event) {
                        var _Object$assign8;

                        var _event$target2 = event.target,
                            name = _event$target2.name,
                            value = _event$target2.value;
                        setFilters(Object.assign(_extends({}, filters), (_Object$assign8 = {}, _Object$assign8[name] = value, _Object$assign8)));
                      }
                    });
                }

                break;

              case "ENUM":
                {
                  var Type = _this3.getSchemaType(function (n) {
                    return n.name === typeName && n.kind === typeKind;
                  });

                  if (Type) {
                    var enumValues = Type.enumValues;
                    _field = _react2.default.createElement(_materialUi.FormControl, {
                      fullWidth: true,
                      style: {
                        minWidth: 150
                      }
                    }, _react2.default.createElement(_materialUi.InputLabel, null, name), _react2.default.createElement(_materialUi.Select, {
                      value: value || "",
                      onChange: function onChange(event) {
                        var _Object$assign9;

                        var _event$target3 = event.target,
                            name = _event$target3.name,
                            value = _event$target3.value;
                        setFilters(Object.assign(_extends({}, filters), (_Object$assign9 = {}, _Object$assign9[name] = value, _Object$assign9)));
                      },
                      inputProps: {
                        name: name // id: 'age-simple',

                      }
                    }, enumValues.map(function (n) {
                      var fieldName = n.name;
                      return _react2.default.createElement(_materialUi.MenuItem, {
                        key: fieldName,
                        value: fieldName
                      }, fieldName);
                    })));
                  }
                }
                break;

              default:
                _field = _react2.default.createElement(_materialUi.FormControl, {
                  style: {
                    minWidth: 80
                  }
                }, _react2.default.createElement(_materialUi.Typography, {
                  variant: 'caption'
                }, name), _react2.default.createElement(_materialUi.Typography, null, value === undefined ? null : value === null ? "null" : value === true ? "true" : value === false ? "false" : (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== "object" ? value : null));
            }
          } else {
            _field = _react2.default.createElement(_materialUi.InputLabel, null, name);
          } // if (field) {


          input = _this3.renderInputBlock(_field, name, index, filters, setFilters, deleteItem); // }
        }

      if (input) {
        inputs.push(input);
      }
    }); // return inputs;

    var addFilter = void 0;

    if (inputFields) {
      addFilter = _react2.default.createElement(_AddFilter2.default, {
        inputFields: inputFields,
        onChange: function onChange(event) {
          var value = event.target.value;
          var inputField = inputFields.find(function (n) {
            return n.name === value;
          });
          var name = inputField.name,
              type = inputField.type;

          var _getType = _this3.getType(type),
              Type = _getType.Type,
              isList = _getType.isList,
              isNonNull = _getType.isNonNull;

          var kind = Type.kind;

          var newFilters = _extends({}, filters);

          var newValue = void 0;

          switch (kind) {
            case "INPUT_OBJECT":
              newValue = {};
              break;

            default:
              newValue = isList ? undefined : isNonNull ? "" : null;
          }

          if (isList) {
            newValue = newValue !== undefined ? [newValue] : [];
          }

          newFilters[name] = newValue;
          setFilters(newFilters);
        }
      });
    }

    return _react2.default.createElement(Grid, _extends({
      container: true,
      spacing: 8,
      style: _extends({
        overflow: "auto"
      }, style)
    }, other), inputs, _react2.default.createElement(Grid, {
      item: true
    }, addFilter));
  };

  App.prototype.getInputFields = function getInputFields(name) {
    var types = this.context.schema.types;
    var WhereInputType = types.find(function (n) {
      return n.kind === "INPUT_OBJECT" && n.name === name;
    });

    var _ref3 = WhereInputType || {},
        inputFields = _ref3.inputFields;

    return inputFields ? inputFields.filter(function (n) {
      var _ref4 = n || {},
          name = _ref4.name;

      return name && ["AND", "OR", "NOT"].indexOf(name) === -1 && !/(\_in)$/.test(name) ? true : false;
    }) : [];
  };

  App.prototype.getSchemaType = function getSchemaType(filter) {
    var schema = this.context.schema;
    var types = schema.types;
    var Field = types.find(filter);
    return Field;
  };

  App.prototype.render = function render() {
    var _this4 = this;

    var _context = this.context,
        schema = _context.schema,
        Grid = _context.Grid;
    var _props = this.props,
        filters = _props.filters,
        queryName = _props.queryName,
        whereType = _props.whereType;

    if (!schema) {
      return null;
    }

    var queryType = schema.queryType,
        types = schema.types;
    var QueryType = types.find(function (n) {
      return n.kind === "OBJECT" && n.name === queryType.name;
    });
    var fields = QueryType.fields;
    var queryField = fields.find(function (n) {
      return n.name === queryName;
    });

    if (!queryField) {
      return null;
    }

    var args = queryField.args;

    if (!args) {
      return null;
    }

    var whereArg = args.find(function (n) {
      return n.name === "where";
    });

    if (!whereArg) {
      return null;
    }

    var _whereArg$type = whereArg.type,
        whereInputTypeName = _whereArg$type.name,
        kind = _whereArg$type.kind,
        ofType = _whereArg$type.ofType;

    if (!whereInputTypeName && kind === "NON_NULL" && ofType) {
      var name = ofType.name;
      whereInputTypeName = name;
    }

    if (!whereInputTypeName) {
      return null;
    }

    var inputFields = this.getInputFields(whereInputTypeName);
    var filtersJson = void 0;

    if (filters && Object.keys(filters).length) {
      filtersJson = JSON.stringify(filters, null, 2);
    }

    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 16
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, this.renderFilters(filters, function (filters) {
      _this4.setFilters(filters);
    }, null, null, null, inputFields)), filtersJson ? _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement('div', {
      style: {
        whiteSpace: "pre-wrap"
      }
    }, filtersJson)) : null);
  };

  return App;
}(_react.Component), _class.contextType = _context3.default, _class.defaultProps = {
  // queryName: "users",
  whereType: "where"
}, _temp2);
App.propTypes = process.env.NODE_ENV !== "production" ? {
  queryName: _propTypes2.default.string.isRequired,
  whereType: _propTypes2.default.string.isRequired,
  setFilters: _propTypes2.default.func.isRequired
} : {};
exports.default = App;
module.exports = exports['default'];